import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Field from '../Field';

export default class RadioGroupField extends React.Component {
  static propTypes = {
    valueField: PropTypes.object,
    type: PropTypes.oneOf(['radio', 'button']),
    disabled: PropTypes.bool,
    inline: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element])
      .isRequired,
  };

  static defaultProps = {
    valueField: {},
    type: 'radio',
    disabled: false,
    inline: true,
  };

  cloneInput = input => {
    const { type, valueField, disabled, inline } = this.props;

    const onChange = this.props.onChange || valueField.onChange;

    return React.cloneElement(input, {
      checked: get(input, 'props.value') === valueField.value,
      disabled: get(input, 'props.disabled', disabled),
      onChange,
      inline,
      type,
    });
  };

  render() {
    const { type, children } = this.props;
    const inline = this.props.inline || type === 'button';

    return (
      <Field {...this.props}>
        {React.Children.map(children, child =>
          inline ? this.cloneInput(child) : <div>{this.cloneInput(child)}</div>
        )}
      </Field>
    );
  }
}
